export async function getUTXOs(client, { address, minValue }) {
    const data = await client.request({
        method: 'getUTXOs',
        params: {
            address,
            minValue,
        },
    });
    return data;
}
//# sourceMappingURL=getUTXOs.js.map